const TRUSTED_UNTIL_KEY = "spotsurferTrustedUntil";
const AUTH_STORE_KEYS = ["tokens", "useUser", "ownerStore", "parkerStore"];
export const TRUST_BROWSER_DAYS = 30;

const trusted = () => Number(localStorage.getItem(TRUSTED_UNTIL_KEY)) > Date.now();

const clearExpiredTrust = () => {
  if (localStorage.getItem(TRUSTED_UNTIL_KEY) && !trusted()) {
    localStorage.removeItem(TRUSTED_UNTIL_KEY);
    AUTH_STORE_KEYS.forEach(key => localStorage.removeItem(key));
  }
};

export const authStorage = {
  getItem(key) {
    if (import.meta.server) return null;
    clearExpiredTrust();
    return trusted() ? localStorage.getItem(key) : sessionStorage.getItem(key);
  },
  setItem(key, value) {
    if (import.meta.server) return;
    clearExpiredTrust();
    const target = trusted() ? localStorage : sessionStorage;
    const stale = trusted() ? sessionStorage : localStorage;
    target.setItem(key, value);
    stale.removeItem(key);
  },
  removeItem(key) {
    if (import.meta.server) return;
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }
};

export const setAuthPersistence = persist => {
  if (!import.meta.client) return;
  if (persist) {
    localStorage.setItem(
      TRUSTED_UNTIL_KEY,
      String(Date.now() + TRUST_BROWSER_DAYS * 24 * 60 * 60 * 1000)
    );
  } else {
    localStorage.removeItem(TRUSTED_UNTIL_KEY);
  }
  const target = persist ? localStorage : sessionStorage;
  const stale = persist ? sessionStorage : localStorage;
  AUTH_STORE_KEYS.forEach(key => {
    const value = stale.getItem(key);
    if (value !== null) target.setItem(key, value);
    stale.removeItem(key);
  });
};

export const clearAuthPersistence = () => {
  if (!import.meta.client) return;
  localStorage.removeItem(TRUSTED_UNTIL_KEY);
  AUTH_STORE_KEYS.forEach(key => authStorage.removeItem(key));
};
